<template lang="pug">
k-page.post.members
  d-main-image( v-bind=`{ img, show }` @load='pageLoaded' )
  w-go-down
  k-main( :title='title' )
    section.description( v-html='content' )
    section.subscriptions
      subscription-menu(
        v-if='user && (!user.as || user.as.subscriber) && user.membership'
        :target='postData.path'
        ) Change your subscription plan below.
      subscription-menu( v-else :target='postData.path' )
        | Select one of the subscription plans to become a member.
</template>

<script lang="js">
import he from 'he'
import _wpapix from '@/lib/wpapix'
import KPage from '@/blocks/k-page'
import KMain from '@/blocks/k-main'
import DMainImage from '@/displays/d-main-image'
import WGoDown from '@/widgets/w-go-down'
import SubscriptionMenu from '@/components/subscription-menu'
import { User, Page } from '@/mixins'

export default {
  name: 'MembersPage',
  mixins: [ User, Page ],
  components: { SubscriptionMenu, KPage, KMain, DMainImage, WGoDown },
  props: {},
  data() {
    return {
      promos: [],
      scrollheader: null
    }
  },
  created() {},
  mounted() {
    _wpapix.then( wpapix => {
      var path = new wpapix.Path({ path: '/members' })
      console.log( 'path object', path )
      path.fetch().done( rpost => {
        console.log( 'got members page', rpost )
        this.storedPost = rpost
        document.title = he.decode(
          rpost.title.rendered + ' | ' + this.sstate.site.title )
        window.setTimeout(() => {
          this.promos = rpost.promo_reel || []
        }, 3000 )
      })
    })
  },
  methods: {
  },
  computed: {
    promo_reel() {
      return this.postData.promo_reel || []
    },
    classes() {
      // return { small: !this.promos.length }
      return {}
    }
  }
}
</script>

<style lang="scss">
.members {

}
</style>
